import { Typography } from '@mui/material'

type Props = {
  title: string
}
export const NavSection = (props: Props) => {
  const { title } = props
  return (
    <Typography variant="caption" color="primary.contrastText" pl={2} py={0.5}>
      {title}
    </Typography>
  )
}
